import { OnDestroy, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import { getMetaDataSelector, getOverallMetaDataSelector, getProjectsSelector } from '../reports.reducer';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportsService } from '../reports.service';
import { saveAs as importedSaveAs } from 'file-saver';
import { DATE_FORMAT } from '../../shared/utils/dateUtils';
import { NotificationService } from '../../shared/notification.service';
import { markFormAsTouched } from '../../lead-generation/shared/reactive-forms/forEachElementInForm';
import { AmplitudeService } from '../../shared/services/amplitude.service';
import { getUserDetailsSelector } from '../../shared/user/user.reducer';
var ReportsComponent = /** @class */ (function () {
    function ReportsComponent(fb, store, translate, router, activatedRoute, reportsService, notificationService, amplitudeService) {
        var _this = this;
        this.fb = fb;
        this.store = store;
        this.translate = translate;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.reportsService = reportsService;
        this.notificationService = notificationService;
        this.amplitudeService = amplitudeService;
        this.inProgress = false;
        this.successReportsCount = null;
        this.failureReportsCount = null;
        this.selectReportsCheckbox = new FormControl(false);
        this.isAdministrativeUser = false;
        this.store.select(getMetaDataSelector).subscribe(function (reportMetaData) {
            _this.reportMetaData = reportMetaData;
            _this.prepareReportTypes();
        });
        this.store.select(getOverallMetaDataSelector).subscribe(function (overallReportMetaData) {
            _this.overallReportMetaData = overallReportMetaData;
        });
        this.store.select(getUserDetailsSelector).subscribe(function (details) {
            _this.isAdministrativeUser = details.administrative;
        });
        this.translate.onLangChange.subscribe(function () {
            _this.prepareReportTypes();
        });
        var downloadToken = this.activatedRoute.snapshot.queryParamMap.get('download');
        if (downloadToken) {
            this.reportsService.downloadAsyncReports(downloadToken);
        }
        //TODO REMOVE AFTER VERSION 2.164 with com.crazycall.web.report.AsyncReportController
        var oldToken = this.activatedRoute.snapshot.queryParamMap.get('download-id');
        if (oldToken) {
            this.reportsService.downloadOldReport(oldToken);
        }
    }
    ReportsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.createEmptyForm();
        this.store.select(getProjectsSelector).subscribe(function (projects) {
            _this.projects = projects.sort(function (a, b) { return a.status.localeCompare(b.status); });
        });
    };
    ReportsComponent.prototype.ngOnDestroy = function () {
        this.notificationService.dismiss();
    };
    ReportsComponent.prototype.changeReportTypes = function (event) {
        var selectedReportTypeValue = this.selectedReportTypes.value;
        var selectReportsCheckboxValue = false;
        if (event.checked) {
            selectedReportTypeValue.push(event.source.value);
        }
        else {
            selectedReportTypeValue = selectedReportTypeValue.filter(function (el) { return el !== event.source.value; });
        }
        this.selectedReportTypes.setValue(selectedReportTypeValue);
        if (selectedReportTypeValue.length) {
            selectReportsCheckboxValue = this.reportTypes.length === selectedReportTypeValue.length ? true : null;
        }
        this.selectReportsCheckbox.setValue(selectReportsCheckboxValue);
    };
    ReportsComponent.prototype.changeSelectAllState = function (isSelect) {
        if (isSelect === null) {
            return;
        }
        var selectedReportTypes = isSelect ? this.reportTypes.map(function (el) { return el.type; }) : [];
        this.selectedReportTypes.setValue(selectedReportTypes);
    };
    ReportsComponent.prototype.isChecked = function (reportType) {
        return this.selectedReportTypes.value.includes(reportType);
    };
    Object.defineProperty(ReportsComponent.prototype, "selectedReportTypes", {
        get: function () {
            return this.reportsForm.controls.reportTypes;
        },
        enumerable: true,
        configurable: true
    });
    ReportsComponent.prototype.changeDateRange = function (_a, form) {
        var dateFrom = _a.dateFrom, dateTo = _a.dateTo;
        form.get('dateFrom').setValue(moment(dateFrom).format(DATE_FORMAT));
        form.get('dateUntil').setValue(moment(dateTo).format(DATE_FORMAT));
    };
    ReportsComponent.prototype.selectAllProjects = function () {
        var projectIds = this.projects.map(function (project) { return project.id; });
        this.reportsForm.controls.projectIds.setValue(projectIds);
    };
    ReportsComponent.prototype.unselectAllProjects = function () {
        this.reportsForm.controls.projectIds.setValue([]);
    };
    ReportsComponent.prototype.downloadProjectReportsAsync = function () {
        if (!this.reportsForm.valid) {
            markFormAsTouched(this.reportsForm);
            return;
        }
        this.doDownloadReportsAsync(this.reportsForm.getRawValue());
    };
    ReportsComponent.prototype.downloadOverallReport = function () {
        this.doDownloadReportsAsync(this.overallReportsForm.getRawValue());
    };
    ReportsComponent.prototype.doDownloadReportsAsync = function (form) {
        var _this = this;
        this.inProgress = true;
        this.sendReportEventToAmplitude('Panel:Reports:Download: Start', form);
        this.reportsService.generateReportsAsync(form).subscribe(function (reportTypesGenerated) {
            _this.inProgress = false;
            _this.showReportMessage(reportTypesGenerated.length, form.reportTypes.length);
            _this.sendReportEventToAmplitude('Panel:Reports:Download: Success', form);
        }, function () {
            _this.sendReportEventToAmplitude('Panel:Reports:Download: Error', form);
        });
    };
    ReportsComponent.prototype.showReportMessage = function (reportTypesGenerated, reportTypesSelected) {
        this.notificationService.open(this.getReportGeneratedMessage(reportTypesGenerated, reportTypesSelected), {
            generatedReportsCount: reportTypesGenerated,
            selectedReportsCount: reportTypesSelected
        }, this.notificationService.getDefaultCloseAction());
    };
    ReportsComponent.prototype.downloadProjectReports = function () {
        if (!this.reportsForm.valid) {
            markFormAsTouched(this.reportsForm);
            return;
        }
        this.generateReports(this.reportsForm.getRawValue());
    };
    ReportsComponent.prototype.generateReports = function (filters) {
        var _this = this;
        this.inProgress = true;
        this.reportsService.generateReports(filters).subscribe(function (response) {
            if (response.successReportsCount) {
                var blob = new Blob([response.blob], { type: 'application/zip, application/x-ms-excel' });
                importedSaveAs(blob, response.fileName);
            }
            _this.successReportsCount = response.successReportsCount;
            _this.failureReportsCount = filters.reportTypes.length - response.successReportsCount;
            _this.inProgress = false;
        }, function () { return (_this.inProgress = false); });
    };
    ReportsComponent.prototype.isNoReportsGenerated = function () {
        return this.successReportsCount === 0;
    };
    ReportsComponent.prototype.isPartialReportsGenerated = function () {
        return this.failureReportsCount > 0 && this.successReportsCount > 0;
    };
    ReportsComponent.prototype.createEmptyForm = function () {
        var today = moment().format(DATE_FORMAT);
        this.reportsForm = this.fb.group({
            dateFrom: [today, Validators.required],
            dateUntil: [today, Validators.required],
            projectIds: [[], Validators.required],
            reportTypes: [[], Validators.required],
            timezoneOffsetMinutes: moment().utcOffset()
        });
        this.overallReportsForm = this.fb.group({
            dateFrom: [today, Validators.required],
            dateUntil: [today, Validators.required],
            reportTypes: new Array(this.overallReportMetaData.types),
            timezoneOffsetMinutes: moment().utcOffset()
        });
    };
    ReportsComponent.prototype.prepareReportTypes = function () {
        var _this = this;
        this.reportTypes = this.reportMetaData.types
            .map(function (el) { return _this.prepareReportType(el); })
            .sort(function (a, b) { return a.title.localeCompare(b.title); });
    };
    ReportsComponent.prototype.prepareReportType = function (type) {
        return { type: type, title: this.translate.instant("REPORT." + type) };
    };
    ReportsComponent.prototype.getReportGeneratedMessage = function (reportTypesGenerated, reportTypesSelected) {
        if (!reportTypesGenerated) {
            return 'REPORTS.NO_DATA';
        }
        if (reportTypesGenerated !== reportTypesSelected) {
            return 'REPORTS.PARTIAL_RESULT';
        }
        return 'REPORTS.ALL_DATA_GENERATED';
    };
    ReportsComponent.prototype.sendReportEventToAmplitude = function (eventName, form) {
        this.amplitudeService.logEvent(eventName, {
            reportStartDate: form.dateFrom,
            reportEndDate: form.dateUntil,
            reportPeriod: moment(form.dateUntil).diff(moment(form.dateFrom), 'days') + 1,
            reportProjectsIds: form.projectIds || [],
            reportProjectsNumber: form.projectIds ? form.projectIds.length : 0,
            reportTypes: form.reportTypes,
            reportTypesNumber: form.reportTypes.length
        });
    };
    return ReportsComponent;
}());
export { ReportsComponent };
